import {Heading} from '@primer/react'
import type {ReactNode} from 'react'

import styles from './RepositoryProjects.module.css'

interface ProjectsActionsProps {
  heading: string
  trailing?: ReactNode
}

export function ProjectsActions({heading, trailing}: ProjectsActionsProps) {
  return (
    <div className={styles.buttonGrp}>
      <Heading as="h1" className={styles.heading}>
        {heading}
      </Heading>
      {trailing}
    </div>
  )
}
